module.exports = __webpack_public_path__ + "media/video-thumbnails/MA-logo-spinner-7a82cb27.gif";